// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"d513e978","453":"ea2e6e51","455":"271998b9"}[chunkId] + ".chunk.js";
};